import { render, staticRenderFns } from "./AddEditEventDetails.vue?vue&type=template&id=3a34f58c"
import script from "./AddEditEventDetails.vue?vue&type=script&lang=js"
export * from "./AddEditEventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports